// ✅ REMOVIDO: AreaServicio ya no se usa en la app global

const ABREVIATURAS: Record<string, string> = {
  'av.': 'avenida',
  'avda.': 'avenida',
  'c.': 'calle',
  'sta.': 'santa',
  'sto.': 'santo',
  'gral.': 'general',
  'cnel.': 'coronel',
  'dr.': 'doctor',
  'dra.': 'doctora',
  'ing.': 'ingeniero',
  'prof.': 'profesor',
  'profa.': 'profesora',
  'esq.': 'esquina',
};

// ✅ REMOVIDO: AREAS_SERVICIO ya no se usa en la app global

export const normalizarDireccion = (direccion: string): string => {
  let normalizada = direccion.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '') // Eliminar acentos
    .replace(/\s+/g, ' ')            // Normalizar espacios
    .trim();

  // Expandir abreviaturas comunes
  Object.entries(ABREVIATURAS).forEach(([abrev, completa]) => {
    const regex = new RegExp(`\\b${abrev}\\b`, 'g');
    normalizada = normalizada.replace(regex, completa);
  });

  return normalizada;
};

export const validarCoordenadas = (
  lat: number, 
  lng: number, 
  // ✅ Parámetro país removido - ya no se usa en la app global
): boolean => {
  // ✅ ACEPTAR CUALQUIER PAÍS para app global
  // Solo validar que las coordenadas sean válidas globalmente
  return (
    lat >= -90 && lat <= 90 &&     // Latitud válida
    lng >= -180 && lng <= 180      // Longitud válida
  );
};

export const obtenerUrlMapa = (placeId: string): string => {
  return `https://maps.google.com/?q=place_id:${placeId}`;
};

export const FIELDS_PLACES = [
  'place_id',
  'formatted_address',
  'geometry',
  'address_components',
  'types',
  'partial_match'
] as const;

export const MAX_REINTENTOS = 3;
export const DELAY_BASE = 1000; // 1 segundo

export const esperarConBackoff = async (intento: number): Promise<void> => {
  const delay = Math.min(DELAY_BASE * Math.pow(2, intento), 10000);
  await new Promise(resolve => setTimeout(resolve, delay));
}; 